import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Radar could not start: no #root element in the page.");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
